import { useUser } from "src/atoms/user";
import { Page } from "src/components";
import { useModals } from "src/components/Modals";
import { Button, Color, Flex, Text } from "src/elements";

const InfoRow = ({ label, value }: { label: string; value: string }) => (
  <Flex align="center" gap="20px">
    <Flex width="120px" flexShrink={0}>
      <Text variant="body2" color={Color.spaceGray}>
        {label}
      </Text>
    </Flex>

    <Text variant="body2">{value}</Text>
  </Flex>
);

export const PageProfile = () => {
  const { user } = useUser();
  const { openModal } = useModals();

  const fullName = `${user.firstName} ${user.lastName}`;
  const role = user.roleCode.charAt(0) + user.roleCode.slice(1).toLowerCase().replace(/_/g, " ");
  const createdAt = user.createdAt
    ? new Date(user.createdAt).toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : null;

  return (
    <Page>
      <Flex column gap="10px">
        <Flex padding="10px 0 0 0">
          <Text variant="h3">Profile</Text>
        </Flex>

        <Flex
          column
          gap="16px"
          padding="24px"
          background={Color.white}
          borderRadius="6px"
          maxWidth="480px"
        >
          <InfoRow label="Name" value={fullName} />
          <InfoRow label="Email" value={user.email} />
          <InfoRow label="Role" value={role} />
          <InfoRow label="Merchant" value={user.merchantName} />
          <InfoRow label="Merchant ID" value={String(user.merchantId)} />
          {createdAt && <InfoRow label="Member since" value={createdAt} />}

          {user.ssoProvider === "NON_SSO" && (
            <Flex borderTop={`1px solid ${Color.lightGray}`} padding="8px 0 0 0">
              <Button onClick={() => openModal("ChangeOwnPasswordModal")}>Change Password</Button>
            </Flex>
          )}
        </Flex>
      </Flex>
    </Page>
  );
};
